import type { QueryClient } from '@tanstack/react-query';
import {
  clearApplicationsHydrateComplete,
  type ApplicationListSync,
} from '@/lib/applicationListSync';
import { loadRecentSettledApplications } from '@/lib/recentSettledApplications';

/**
 * Applications tab mount / F5 / bfcache: restore session overlay, drop stale list
 * caches when session is empty (DevTools clear, other browser).
 */
export function bootstrapApplicationsListOnMount(
  companyId: string,
  queryClient: QueryClient,
  listSync: ApplicationListSync,
  options?: { pageReload?: boolean },
): void {
  const recent = loadRecentSettledApplications(companyId);
  if (recent.length > 0) {
    listSync.patchMany(companyId, recent, false);
    if (options?.pageReload) {
      return;
    }
  }

  if (recent.length === 0) {
    clearApplicationsHydrateComplete(companyId);
    queryClient.removeQueries({ queryKey: ['applications-list', companyId] });
    queryClient.removeQueries({ queryKey: ['applications', companyId] });
  }
}

/** Refetch company list after bfcache restore (frozen React Query state). */
export function refetchApplicationsListAfterBfcache(
  queryClient: QueryClient,
  companyId: string,
): void {
  void queryClient.invalidateQueries({ queryKey: ['applications-list', companyId] });
}
